import { PerformanceReportForProfessionalsRankingOrderColumn } from 'presentation/app/modules/Reports/models/performance-report-for-professionals';

export const getAbbreviatedProfessionalName = (name: string) => {
  if (!name) return '';

  const [firstName = '', secondName = ''] = name.trim().split(/\s+/);

  if (!secondName) {
    return firstName;
  }

  return `${firstName} ${secondName.charAt(0)}.`;
};

export const getOrderColumnByTableColumnId = (
  columnId?: number,
): PerformanceReportForProfessionalsRankingOrderColumn => {
  switch (columnId) {
    case 1:
      return 'NAME';
    case 2:
      return 'EMPLOYMENT_RELATIONSHIP';
    case 3:
      return 'WEEKLY_WORKLOAD';
    case 4:
      return 'FINISHED_ACTIVITIES';
    case 5:
      return 'MISSED_JUSTIFIED_VALIDATED_ACTIVITIES';
    case 6:
      return 'EVALUATIONS';
    case 7:
      return 'LAST_LOGIN';
    default:
      return 'FINISHED_ACTIVITIES';
  }
};
